(function () {
  const $ = (s, root = document) => root.querySelector(s);
  const $$ = (s, root = document) => Array.from(root.querySelectorAll(s));
  const money = (cents) => `$${(Number(cents || 0) / 100).toFixed(0)}`;
  const parse = (id) => JSON.parse($(id).textContent);

  const products = parse('#artcakes-products');
  const catalog = parse('#artcakes-catalog');
  const galleryAssets = parse('#artcakes-assets');
  const addOns = [
    ['inscription', 'Inscription', 5, true], ['bows', 'Bows', 5, true],
    ['pearls', 'Pearls', 10], ['cherries', 'Cherries', 10],
    ['buttercream-flowers', 'Buttercream flowers', 10, true],
    ['dried-flowers', 'Dried flowers', 10, true], ['disco-balls', 'Disco balls', 15],
    ['custom-figure', 'Custom Figure', 60], ['edible-image', 'Edible Image', 30]
  ];
  let selected = null;
  let activeImage = 0;

  const menu = $('.menu');
  if (menu) menu.addEventListener('click', () => {
    menu.classList.toggle('isOpen');
    $('.mobileNav').classList.toggle('isOpen');
  });
  $$('.mobileNav a').forEach((a) => a.addEventListener('click', () => {
    menu.classList.remove('isOpen'); $('.mobileNav').classList.remove('isOpen');
  }));

  const grid = $('#catalog-grid');
  catalog.forEach((cake, i) => {
    const p = products[cake.handle];
    const from = p && p.variants && p.variants.length ? money(Math.min(...p.variants.map(v => Number(v.price)))) : '';
    const button = document.createElement('button');
    button.type = 'button'; button.className = 'catalogCard'; button.dataset.handle = cake.handle;
    button.innerHTML = `<span class="catalogImage"><img src="${cake.images[0]}" alt="${cake.name}"><i>${String(i + 1).padStart(2, '0')}</i></span><span class="catalogInfo"><span><small>${cake.category}</small><strong>${cake.name}</strong></span><b>${from ? `From ${from}` : 'Import product CSV'}</b></span>`;
    button.addEventListener('click', () => selectCake(cake));
    grid.appendChild(button);
  });

  function selectCake(cake) {
    selected = cake; activeImage = 0;
    $$('.catalogCard').forEach(el => el.classList.toggle('selected', el.dataset.handle === cake.handle));
    $('#cake-customizer').hidden = false;
    $('#cake-name').textContent = cake.name;
    const p = products[cake.handle];
    const sizes = p && p.variants ? p.variants : [];
    $('#starting-price').textContent = sizes.length ? `From ${money(Math.min(...sizes.map(v => Number(v.price))))}` : 'Import the included products CSV to enable checkout';
    renderImages(); renderSizes(); renderAddOns(); updateSteps(); updateTotal();
    $('#cake-customizer').scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function renderImages() {
    $('#reference-main').src = selected.images[activeImage];
    $('#reference-label').textContent = `Reference selected · ${String(activeImage + 1).padStart(2, '0')}`;
    const thumbs = $('#reference-thumbs'); thumbs.innerHTML = '';
    selected.images.forEach((src, i) => {
      const b = document.createElement('button'); b.type = 'button'; b.className = i === activeImage ? 'active' : '';
      b.innerHTML = `<img src="${src}" alt="Design reference ${i + 1}">`;
      b.addEventListener('click', () => { activeImage = i; renderImages(); }); thumbs.appendChild(b);
    });
  }

  function renderSizes() {
    const holder = $('#size-options'); holder.innerHTML = '';
    const p = products[selected.handle];
    if (!p || !p.variants) { holder.innerHTML = '<p class="setupNotice">Import ArtCakes-Shopify-Products.csv first.</p>'; return; }
    p.variants.forEach((v, i) => {
      const label = document.createElement('label');
      label.innerHTML = `<input type="radio" name="cake-size" value="${v.id}" ${i === 0 ? 'checked' : ''}><span>${v.title}<b>${money(v.price)}</b></span>`;
      label.querySelector('input').addEventListener('change', updateTotal); holder.appendChild(label);
    });
  }

  function renderAddOns() {
    const holder = $('#addon-options'); holder.innerHTML = '';
    addOns.forEach(([id, label, price, color]) => {
      const row = document.createElement('div'); row.className = 'addOnRow';
      row.innerHTML = `<label><input type="checkbox" value="${id}"><span>${label}</span><b>+$${price}</b></label>${color ? `<label class="detailColor" hidden><input type="color" value="#d5a4ad"><span>${label} color</span></label>` : ''}`;
      const check = $('input[type="checkbox"]', row); check.addEventListener('change', () => { const detail = $('.detailColor', row); if (detail) detail.hidden = !check.checked; updateTotal(); });
      holder.appendChild(row);
    });
  }

  function updateSteps() {
    const vintage = !!selected.vintage;
    $('#addon-group').hidden = !vintage;
    $('#date-step').textContent = vintage ? '5. Event date' : '4. Event date';
    $('#wishes-step').textContent = vintage ? '6. Additional wishes' : '5. Additional wishes';
  }

  function updateTotal() {
    if (!selected) return;
    const p = products[selected.handle];
    const sizeId = Number($('input[name="cake-size"]:checked')?.value);
    const variant = p?.variants?.find(v => Number(v.id) === sizeId) || p?.variants?.[0];
    let cents = Number(variant?.price || 0);
    if (selected.vintage) $$('#addon-options input[type="checkbox"]:checked').forEach(cb => { const found = addOns.find(a => a[0] === cb.value); cents += Number(found?.[2] || 0) * 100; });
    $('#product-total').textContent = cents ? money(cents) : '—';
  }

  const dateInput = $('#event-date');
  const earliest = new Date(); earliest.setHours(12, 0, 0, 0); earliest.setDate(earliest.getDate() + 3);
  dateInput.min = earliest.toISOString().slice(0, 10);
  dateInput.addEventListener('change', validateDate);
  function validateDate() {
    const value = dateInput.value; let msg = '';
    if (value && value < dateInput.min) msg = 'Please choose a date with at least 3 days’ notice.';
    if (value >= '2026-10-28' && value <= '2026-11-13') msg = 'ArtCakes is unavailable from October 28 through November 13.';
    $('#date-error').textContent = msg; dateInput.setCustomValidity(msg); return !msg;
  }

  $('#add-to-cart').addEventListener('click', async () => {
    if (!selected || !validateDate() || !dateInput.reportValidity()) return;
    const p = products[selected.handle];
    const variantId = $('input[name="cake-size"]:checked')?.value;
    if (!p || !variantId) { alert('Please import ArtCakes-Shopify-Products.csv before testing checkout.'); return; }
    const colors = $$('.colorOptions input[type="color"]').map(i => i.value).join(', ');
    const properties = { 'Design reference': `Image ${activeImage + 1}`, 'Flavor': $('#cake-flavor').value, 'Cake colors': colors, 'Event date': dateInput.value };
    if ($('#cake-notes').value.trim()) properties['Additional wishes'] = $('#cake-notes').value.trim();
    const items = [{ id: variantId, quantity: 1, properties }];
    if (selected.vintage) {
      $$('#addon-options input[type="checkbox"]:checked').forEach(cb => {
        const ap = products[`add-on-${cb.value}`]; if (!ap?.variants?.[0]) return;
        const row = cb.closest('.addOnRow'); const color = $('.detailColor input', row)?.value;
        items.push({ id: ap.variants[0].id, quantity: 1, properties: color ? { 'Detail color': color, 'For cake': selected.name } : { 'For cake': selected.name } });
      });
    }
    const button = $('#add-to-cart'); button.disabled = true; button.textContent = 'Adding…';
    try {
      const root = window.Shopify?.routes?.root || '/';
      const res = await fetch(`${root}cart/add.js`, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items }) });
      if (!res.ok) {
        const error = await res.json().catch(() => ({}));
        throw new Error(error.description || error.message || 'Shopify could not add this selection.');
      }
      window.location.href = `${root}cart`;
    } catch (e) { console.error(e); alert(e.message || 'We could not add this cake. Please refresh and try again.'); button.disabled = false; button.textContent = 'Add to cart'; }
  });

  const overlay = $('#portfolio-overlay');
  $$('.portfolioCard').forEach(card => card.addEventListener('click', () => {
    $('#gallery-title').textContent = card.dataset.title; const holder = $('#gallery-grid'); holder.innerHTML = '';
    (galleryAssets[card.dataset.gallery] || []).forEach((src, i) => { const b = document.createElement('button'); b.type = 'button'; b.className = 'portfolioGalleryImage'; b.innerHTML = `<img src="${src}" alt="${card.dataset.title} — design ${i + 1}">`; holder.appendChild(b); });
    overlay.hidden = false; document.body.style.overflow = 'hidden';
  }));
  $('#gallery-close').addEventListener('click', closeGallery); overlay.addEventListener('click', e => { if (e.target === overlay) closeGallery(); });
  function closeGallery() { overlay.hidden = true; document.body.style.overflow = ''; }
})();
